export const LIST_SORT_KEYS = ['checked', 'alphabet', 'priceAsc', 'priceDesc'];
export const CATALOG_SORT_KEYS = ['longAgo', 'recent', 'alphabet', 'priceAsc', 'priceDesc'];

export const DEFAULT_LIST_SORT = 'checked';
export const DEFAULT_CATALOG_SORT = 'longAgo';

const LEGACY_LIST_SORT_MAP = {
  Checked: 'checked',
  Alphabet: 'alphabet',
  'Low to high price': 'priceAsc',
  'High to low price': 'priceDesc',
};

const LEGACY_CATALOG_SORT_MAP = {
  'Long-ago purchased': 'longAgo',
  'Recently purchased': 'recent',
  Alphabet: 'alphabet',
  'Low to high price': 'priceAsc',
  'High to low price': 'priceDesc',
};

export const normalizeListSortKey = (value) => {
  if (!value) return DEFAULT_LIST_SORT;
  if (LIST_SORT_KEYS.includes(value)) return value;
  return LEGACY_LIST_SORT_MAP[value] || DEFAULT_LIST_SORT;
};

export const normalizeCatalogSortKey = (value) => {
  if (!value) return DEFAULT_CATALOG_SORT;
  if (CATALOG_SORT_KEYS.includes(value)) return value;
  return LEGACY_CATALOG_SORT_MAP[value] || DEFAULT_CATALOG_SORT;
};
